<template>



<b-collapse tag="aside" id="catalog-filters">

    <section class="categories">
        <ul class="category-list">
            <li v-for="cat in available" :key="cat.slug" class="category">

                <router-link :to="{ name: 'category', params: { categorySlug: cat.slug }}">
                    <span class="label">{{ cat.name }}</span>
                    <span class="qty right">{{ counts[cat.slug] }}</span>
                </router-link>

                <!-- <transition-expand>
                </transition-expand> -->
                <ul v-show="category == cat && cat.subcategories" class="subcategory-list">
                    <li v-for="sub in cat.subcategories" :key="sub.slug" class="subcategory">
                        <router-link :to="{ name: 'subcategory', params: { categorySlug: cat.slug, subcategorySlug: sub.slug }}">
                            <span class="label">{{ sub.name }}</span>
                            <span class="qty right">{{ counts[sub.slug] }}</span>
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
    </section>

    <hr>

    <section>
        <h5>Filter By:</h5>
        <form>
        <ul class="filter-list">
            <slot name="filters">
            </slot>
        </ul>
        </form>
    </section>

    <hr>

    <p class="text-right filter-reset">
        <a @click.prevent="$emit('filter-reset')" href="#">Reset all filters</a>
    </p>

</b-collapse>
</template>

<script>

    import CatalogFilter from '@/components/CatalogFilter.vue'
    // import TransitionExpand from './TransitionExpand.vue'

    export default {
        props: {
            category: Object,
            categories: Array,
            counts: Object,
            filters: Object,
        },
        computed: {
            available: function() {
                const available = this.categories.slice(0);
                for (const cat of available) {
                    cat.subcategories = cat.subcategories.filter((sub)=>(this.counts[sub.slug]));
                }
                return available;
            }
        },
        components: {
            CatalogFilter,
            // TransitionExpand,
        }
    }

</script>


<style lang="scss">

    @import "@/scss/common.scss";

    aside#catalog-filters {

        background-color: rgba(white, 0.90);
        position: absolute;
        z-index: 100;

        left: $spacer * 2;
        right: $spacer;
        top: -15px;

        margin-bottom: $spacer;
        padding: $spacer;
        border: 1px solid darken($primary, 10%);
        border-top: 3px solid darken($primary, 10%);

        @media (min-width: map-get($grid-breakpoints, "sm" )) {
            position: static !important;
            display: block !important;
            margin: 0 !important;
            padding: 0 !important;
            border: none !important;
        }

        & + .catalog-filter-close {
            @include transition(all 0.5s ease);
            visibility: hidden;
            position: fixed;
            z-index: 10;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;

        }

        &.show + .catalog-filter-close,
        &.collapsing + .catalog-filter-close {
            @include transition(all 0.5s ease);
            visibility: visible;
            background-color: rgba(black, 0.4);
        }

        .filter-reset {
            font-size: 12px;
            letter-spacing: 0.5pt;
            a { color: $primary; }
        }

        .filter-list, .category-list {

            list-style: none;
            padding: 0;

            ul {
                list-style: none;
                padding: 0;
            }

            li {

            }

            & > li {
                margin-bottom: 12px;
                font-size: 22px;
                line-height: 28px;
                & > a {
                    color: $primary;
                }

                .router-link-active {
                    border-left: 5px solid $primary;
                    padding-left: 10px;
                    margin-left: -15px;
                    color: $dark;
                    font-weight: 400;
                }

                a:hover,
                .filter-option:hover {
                    // text-decoration: underline;
                    // background-color: $falesca-lighter;

                    border-left: 5px solid $primary;
                    padding-left: 10px;
                    margin-left: -15px;
                }


            }

            & > li > ul > li {
                line-height: 28px;
                font-size: 16px;
                label, a {
                    color: $secondary;
                }
                a:hover {
                    color: $primary;
                }
            }

            .filter a[aria-expanded=true] {
                i.up { display: block !important; }
                i.down { display: none; }
            }

            a, .filter-option {

                display: block;
                display: flex;
                align-items: baseline;
                color: $primary;
                letter-spacing: 0.025em;

                label, .label {
                    margin-right: auto;
                    padding-right: 15px;
                    flex-grow: 1;

                    &.disabled {
                        color: #EEE;
                    }
                }


            }

            .right {
                font-size: 16px;
            }

        }

        section.categories {
            // min-height: 500px;
        }

    }


</style>
